// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qa_a bha_rq bha_kr bha_ks","PostDetailRight__brandDaysPosts":"qa_b bha_rq bha_kr bha_ks"};